import React, { useState, useRef, useEffect } from 'react';
import './ChatBot.css';

const ANSWERS = {
  price: `대관료는 요일 및 시간대에 따라 상이합니다.

· 11시 – 15시 (준비시간 포함 4시간)
· 17시 – 21시 (준비시간 포함 4시간)
· 17시 – 23시 (애프터파티 포함)

정확한 견적은 예약 신청 후 담당자가 개별 안내드리겠습니다.`,
  partner: `케이터링, 플라워데코, 본식 스냅 및 영상, 웨딩디렉터는 Garden Poète 제휴업체를 통해 소개해 드립니다.

Garden Poète는 제휴업체로부터 어떠한 수수료도 받지 않으며, 예약 신청 후 담당자와 상담 과정에서 함께 안내드리겠습니다.`,
  space: `Garden Poète는 홍대 인근 약 300평 규모의 저택형 하우스 웨딩 베뉴입니다.

유럽식 정원과 내부 홀을 갖추고 있으며, 70-200명 규모의 프라이빗 예식에 최적화되어 있습니다.`,
  parking: `건물 내 주차는 최대 8대까지 가능합니다.

대중교통 이용 시 6호선 상수역에서 도보 4분 거리입니다.

[ 주변 주차장 ]
· 홍익대학교 나이스파크
· 극동방송 지하주차장
· 서교주차장
· 합정공영주차장`,
  guide: `[ 예식 안내 ]
예식 가능 인원: 70-200명
예식 시간: 준비시간 포함 4시간

[ 예약 및 계약 절차 ]
예약 신청 → 담당자 상담 → 제휴업체 가용 확인 → 예약 확정 → 계약 체결

[ 납입 안내 ]
예약금 2,000,000원은 상담 후 1주일 이내 납입 시 예약이 확정됩니다.
잔금 및 제휴업체 대금은 예식 2주 전 일괄 납입하셔야 합니다.
예식 2주 전 최종 하객 수가 확정되며, 이후 하향 변경은 불가합니다.

[ 취소 규정 ]
· 예식 150일 이전: 예약금 전액 환불
· 149일 – 90일 전: 예약금 미환불
· 89일 – 60일 전: 예약금 미환불 + 대관료 30%
· 59일 – 30일 전: 예약금 미환불 + 대관료 50%
· 29일 – 당일: 예약금 미환불 + 대관료 100%
· 베뉴 귀책사유: 전액 환불

[ 시간 초과 ]
계약 시간 초과 시 시간당 330,000원(부가세 포함)이 부과됩니다. 1시간 미만은 1시간으로 계산합니다.

[ 제휴업체 안내 ]
Garden Poète는 제휴업체로부터 어떠한 수수료도 받지 않으며, 제휴업체의 서비스 과실에 대한 책임은 해당 업체에 있습니다.`
};

const LABELS = {
  price: '대관 가격',
  partner: '제휴업체 추천',
  space: '공간 소개',
  parking: '주차 문의',
  guide: '웨딩 가이드'
};

export default function ChatBot() {
  const [open, setOpen] = useState(false);
  const [screen, setScreen] = useState('chat'); // chat | form | done
  const [messages, setMessages] = useState([
    { type: 'b', text: '안녕하세요.\nGarden Poète 웨딩 상담입니다.\n\n아래 메뉴에서 궁금하신 항목을 선택해 주세요.' }
  ]);
  const [inputVal, setInputVal] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedPartners, setSelectedPartners] = useState([]);
  const bodyRef = useRef(null);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    window.addEventListener('openChatBot', handleOpen);
    return () => window.removeEventListener('openChatBot', handleOpen);
  }, []);

  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [messages]);

  const addMsg = (text, type) => {
    setMessages(prev => [...prev, { type, text }]);
  };

  const handleMenu = (key) => {
    addMsg(LABELS[key], 'u');
    setTimeout(() => addMsg(ANSWERS[key], 'b'), 400);
  };

  const handleSend = () => {
    const txt = inputVal.trim();
    if (!txt) return;
    setInputVal('');
    addMsg(txt, 'u');
    setTimeout(() => addMsg('말씀해 주셔서 감사합니다.\n담당자가 확인 후 영업일 기준 1–2일 이내 연락드리겠습니다.', 'b'), 500);
  };

  const toggleTime = (val) => {
    setSelectedTime(prev => prev === val ? '' : val);
  };

  const togglePartner = (val) => {
    setSelectedPartners(prev =>
      prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]
    );
  };

  const handleSubmit = () => {
    setScreen('done');
  };

  return (
    <>
      {/* FAB */}
      <div className="chatbot-fab" onClick={() => setOpen(o => !o)}>
        <button className="chatbot-fab-circle" aria-label="문의하기">
          <svg viewBox="0 0 24 24">
            <path d="M20 2H4C2.9 2 2 2.9 2 4v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
          </svg>
        </button>
        <span className="chatbot-fab-label">문의하기</span>
      </div>

      {/* Window */}
      <div className={`chatbot-window${open ? '' : ' hidden'}`}>

        {/* Header */}
        <div className="cb-head">
          <div className="cb-head-row">
            <span className="cb-logo">Garden Poète</span>
            <button className="cb-close" onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="cb-sub">House Wedding · Hongdae</div>
          <div className="cb-status">
            <div className="cb-dot"></div>
            <span className="cb-status-txt">영업일 기준 1–2일 이내 답변드립니다</span>
          </div>
        </div>

        {/* Chat Screen */}
        <div className={`cb-screen${screen === 'chat' ? ' on' : ''}`}>
          <div className="cb-body" ref={bodyRef}>
            {messages.map((m, i) => (
              <div key={i} className={`cb-msg-wrap ${m.type}`}>
                {m.type === 'b' && <div className="cb-sender">Garden Poète</div>}
                <div className={`cb-bubble ${m.type}`}>{m.text}</div>
              </div>
            ))}
          </div>
          <div className="cb-menu-grid">
            <button className="cb-menu-btn" onClick={() => handleMenu('price')}>대관 가격</button>
            <button className="cb-menu-btn" onClick={() => handleMenu('partner')}>제휴업체 추천</button>
            <button className="cb-menu-btn" onClick={() => handleMenu('space')}>공간 소개</button>
            <button className="cb-menu-btn" onClick={() => handleMenu('parking')}>주차 문의</button>
            <button className="cb-menu-btn" onClick={() => setScreen('form')}>예약 신청</button>
            <button className="cb-menu-btn" onClick={() => handleMenu('guide')}>웨딩 가이드</button>
          </div>
          <div className="cb-input-bar">
            <input
              className="cb-input"
              placeholder="메시지를 입력하세요"
              value={inputVal}
              onChange={e => setInputVal(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSend()}
            />
            <button className="cb-send" onClick={handleSend}>
              <svg viewBox="0 0 24 24"><path d="M2 21l21-9L2 3v7l15 2-15 2z"/></svg>
            </button>
          </div>
        </div>

        {/* Form Screen */}
        <div className={`cb-screen${screen === 'form' ? ' on' : ''}`}>
          <div className="cb-form-wrap">
            <div className="cb-form-head">
              <button className="cb-form-back" onClick={() => setScreen('chat')}>← 뒤로</button>
              <span className="cb-form-title">예약 신청</span>
            </div>
            <div className="cb-form-body">
              <div className="cb-fr">
                <span className="cb-fl">예식 희망 날짜</span>
                <input className="cb-fi" type="text" placeholder="예: 10월 11일, 10월 18일 (복수 기입 가능)" />
              </div>
              <div className="cb-fr">
                <span className="cb-fl">예식 시간</span>
                <div className="cb-chips">
                  {['11시 – 15시', '17시 – 21시'].map(t => (
                    <button
                      key={t}
                      className={`cb-chip${selectedTime === t ? ' sel' : ''}`}
                      onClick={() => toggleTime(t)}
                    >{t}</button>
                  ))}
                  <button
                    className={`cb-chip cb-chip-full${selectedTime === '17시 – 23시 · 애프터파티' ? ' sel' : ''}`}
                    onClick={() => toggleTime('17시 – 23시 · 애프터파티')}
                  >17시 – 23시 · 애프터파티</button>
                </div>
              </div>
              <div className="cb-fr">
                <span className="cb-fl">예상 하객 수</span>
                <input className="cb-fi" type="text" placeholder="명" />
              </div>
              <div className="cb-fr">
                <span className="cb-fl">신랑 성함</span>
                <input className="cb-fi" type="text" placeholder="성함을 입력해 주세요" />
              </div>
              <div className="cb-fr">
                <span className="cb-fl">신부 성함</span>
                <input className="cb-fi" type="text" placeholder="성함을 입력해 주세요" />
              </div>
              <div className="cb-fr">
                <span className="cb-fl">대표 연락처</span>
                <input className="cb-fi" type="text" placeholder="010 - 0000 - 0000" />
              </div>
              <div className="cb-fr">
                <span className="cb-fl">제휴업체 상담 희망</span>
                <div className="cb-chips">
                  {['웨딩디렉터', '케이터링', '플라워데코', '스냅 · 영상'].map(p => (
                    <button
                      key={p}
                      className={`cb-chip${selectedPartners.includes(p) ? ' sel' : ''}`}
                      onClick={() => togglePartner(p)}
                    >{p}</button>
                  ))}
                </div>
              </div>
              <div className="cb-fr">
                <span className="cb-fl">기타 문의 사항</span>
                <input className="cb-fi" type="text" placeholder="자유롭게 입력해 주세요" />
              </div>
              <button className="cb-submit" onClick={handleSubmit}>신청서 제출하기</button>
            </div>
          </div>
        </div>

        {/* Done Screen */}
        <div className={`cb-screen${screen === 'done' ? ' on' : ''}`}>
          <div className="cb-done-wrap">
            <div className="cb-done-line"></div>
            <div className="cb-done-check">
              <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div className="cb-done-title">신청이 완료되었습니다</div>
            <div className="cb-done-sub">
              소중한 날을 함께 준비할 수 있도록{'\n'}
              담당자가 영업일 기준 1–2일 이내{'\n'}
              연락드리겠습니다.
            </div>
            <button className="cb-done-btn" onClick={() => { setScreen('chat'); }}>
              처음으로 돌아가기
            </button>
          </div>
        </div>

      </div>
    </>
  );
}
